import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const InfoSection = styled(Flex)`
  gap: 5px;
  margin-left: 10px;
  flex-direction: column;
  min-width: 300px;
  max-width: 400px;
`
export const CompanyName = styled.div`
  font-size: 0.875rem;
  color: ${COLORS.GREY_T_60};
  font-weight: 500;
`
export const RoleName = styled.p`
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 21px;
  padding-bottom: 0;
  margin-bottom: 0;
`
export const BorderDiv = styled.div`
  padding: 0 0.8rem;
  margin: 0 0.6rem;
  border-right: 1px solid ${COLORS.GREY_T_75};
  border-left: 1px solid ${COLORS.GREY_T_75};
`

export const BottomData = styled.div`
  font-size: 0.937rem;
  color: ${COLORS.GREY_T_30};
  font-weight: 400;
  line-height: 20px;
  text-transform: lowercase;
  white-space: nowrap;
  &::first-letter {
    text-transform: capitalize;
  }
`
export const Vacancies = styled(BottomData)`
  white-space: nowrap;
`
export const LocationsDiv = styled(BottomData)`
  white-space: normal;
`
export const RedDot = styled.div`
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 50%;
  background-color: ${COLORS.RED_S2_100};
`
